import { useHairstyleCheckout } from './useHairstyleCheckout';

/**
 * hairstyle-women-quiz counterpart of `useHairstyleCheckout`. The checkout prep
 * (anonymous user + billing auth) is identical for both hairstyle funnels — the
 * funnels only differ in their own quiz state — so this is an alias kept under
 * its own name so the women's paywall reads symmetrically with the men's.
 */
export const useHairstyleWomenCheckout = useHairstyleCheckout;
